import React, {FC} from 'react';

import {DynamicRemotePopup} from '../dynamicRemoteApp/dynamicRemoteApp';

/**
 * Component that load a remote subscribe popup named popupName and written on swelte
 * @param {PropsType} props - props for popup
 * @return {Node} popup in div
 * @public dynamically imported component
 */
export const SubscribePopup: FC<any> = props => (
    <DynamicRemotePopup
        remoteAppInfo={{
            module: './loadPopup',
            scope: 'popups',
            url: process.env.MF_POPUPS_CLIENT_URI as string,
        }}
        props={props}
    />
);
